module.exports = __webpack_public_path__ + "static/media/0323_IMG_TRAD_LE_SOL_CARRELAGE_EXISTANT.45614a4d.webp";